import React from 'react';
export default function ProfileConflict({ visible, busy, onReload }) {
  if (!visible) return null;
  return <div role="alert" className="my-4 rounded-xl border border-amber-300 bg-amber-50 p-4 text-sm">
    <p>Profil başka bir yerde güncellendi. Yazdıkların bu formda korunuyor.</p>
    <button type="button" className="action-secondary mt-3" disabled={busy} onClick={onReload}>Yazdıklarımı koru, güncel bilgileri getir</button>
    <p className="mt-2">Güncel bilgileri getirdikten sonra değişikliklerini kontrol edip yeniden kaydet.</p>
  </div>;
}
